module.exports = __webpack_public_path__ + "static/media/n_icon_kefu.dcfb42ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/n_icon_kefu.png
// module id = 671
// module chunks = 0 1